var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvestorsGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "investors-graph_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.02 66.103H39.551V37.937H51.88M39.67 66.103H27.202V45.738h12.187M27.63 66.103H15.161V51.241h11.764m35.538-34.516L15.698 39.58m45.511-16.55l2.309-6.825-6.824-2.308M52.37 30.87H64.84v35.239H52.37v-35.24z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODAgODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNTIuMDIwMiA2Ni4xMDMxSDM5LjU1MTRWMzcuOTM2OUg1MS44NzkxTTM5LjY2OTkgNjYuMTAzMkgyNy4yMDExVjQ1LjczNzdIMzkuMzg3Nk0yNy42MzAyIDY2LjEwMzJIMTUuMTYxNFY1MS4yNDExSDI2LjkyNDZNNjIuNDYyNiAxNi43MjQ4TDE1LjY5NzYgMzkuNTc5NU02MS4yMDk0IDIzLjAyOTdMNjMuNTE4IDE2LjIwNTVMNTYuNjkzOCAxMy44OTY5TTUyLjM3MDEgMzAuODY5OUg2NC44Mzg5VjY2LjEwODhINTIuMzcwMVYzMC44Njk5WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";
export { SvgInvestorsGraph as ReactComponent };